<script>

	export default {
		name: "ModalCambiarAvatar",
		data() {
			return {
				show: false,
				croppieImage: '',
				cropped: null
			};
		},
		methods: {
			abrirInputFile() {
				let inputFile = document.getElementById("file");
				if (inputFile) inputFile.click();
			},
			croppie (e) {
				this.show = true;
				var files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;
			
				var reader = new FileReader();
				reader.onload = e => {
					this.$refs.croppieRef.bind({
					url: e.target.result
					});
				};
			
				reader.readAsDataURL(files[0]);
			},
			crop() {
				try {
					let options = {
						type: 'base64',
						size: { width: 200, height: 200 },
						format: 'jpeg'
					};
					this.$refs.croppieRef.result(options, output => {
						this.cropped = this.croppieImage = output;
						this.$emit("actualizarImagenPerfil", this.croppieImage);
					});
					this.$refs.modalAvatarVolver.click();
				}
				catch(error) {
					console.log(error);
				}
			},
		cleanData(){
			this.show = false;
			this.cropped = null;
			this.croppieImage = '';
		}
		},
	};
</script>

<template>
	<div 
		class="modal fade" 
		id="modal-cambiar-avatar"
		tabindex="-1"
		>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title font-700 color-main fs-5">
						Cambiar imagen
					</h1>
					<a 
						class="h3 mb-0 link-secondary" 
						href="javascript:"
						data-bs-dismiss="modal"
					>
					<font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>

					</a>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<input 
							type="file"
							id="file"
							class="d-none"
							@change="croppie"
						>
						<a 
							href="javascript:"
							@click="abrirInputFile()"
							class="btn btn-custom btn-custom-line btn-custom-line-gray mt-3 w-100"
						>
						<font-awesome-icon icon="fa-solid fa-paperclip" class="pe-1 color-green" ></font-awesome-icon>
						
							Buscar imagen
						</a> 
					</div>
					<template v-if="!show">
						<div class="zona-imagen d-flex justify-content-center align-items-center">
							<font-awesome-icon icon="fa-solid fa-image"></font-awesome-icon>
						</div>
					</template>
					<template v-if="show">
						<vue-croppie 
							ref="croppieRef" 
							:enableOrientation="true" 
							:boundary="{ height: 400 }" 
							:viewport="{ width:200, height:200, 'type':'square' }"
							:enableResize="false"
						>
						</vue-croppie>
					</template>
				</div>
				<div class="modal-footer">
					<button 
						ref="modalAvatarVolver"
						type="button" 
						class="btn btn-custom btn-custom-line-gray mw-150" 
						data-bs-dismiss="modal">
						<font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2" ></font-awesome-icon>
						Volver
					</button>
					<a 
						@click="crop()"
						href="javascript:"
						class="btn btn-custom btn-custom-main mw-150">
						Guardar
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

